// Import Scss
import './assets/scss/theme.scss';
import Routes from "./routes/index";
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Helmet } from 'react-helmet-async';
import { useAppSettings } from './contexts/AppSettingsContext';
import { setFavicon } from "./utils/commenController"

function App() {
  const { appSettings } = useAppSettings();

  
  useEffect(() => {
    document.title = appSettings?.title || "DataCore";
    if (appSettings.favicon) {
      setFavicon(appSettings.favicon); // Dynamically set the favicon
    } 
  }, [appSettings.title, appSettings.favicon]);

  return (
      <>
        <Helmet>
          <title>{appSettings?.title || "DataCore"}</title>
        </Helmet>
        <Toaster />
         <Routes /> 
      </>
  );
}

export default App;
         